import { ReactNode } from "react";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import useTranslate from "hooks/useTranslate";
import ArrowIcon from "assets/icons/loyalty/arrow.svg?react";
import "./styles.sass";

type LoyaltyNavButtonProps = {
  path: string;
  title: string;
  btnText: string;
  children?: ReactNode;
  className?: string;
};

const LoyaltyNavButton = (props: LoyaltyNavButtonProps) => {
  const { path, title, btnText, children, className } = props;
  const t = useTranslate();
  const classNameBlock = classNames("LoyaltyNavButton", className);

  return (
    <div className={classNameBlock}>
      <div className="LoyaltyNavButton__left">
        <span className="LoyaltyNavButton__title">{t(title)}</span>
        <NavLink to={path} className="LoyaltyNavButton__link">
          {t(btnText)} <ArrowIcon className="LoyaltyNavButton__icon" />
        </NavLink>
      </div>
      {children}
    </div>
  );
};

export default LoyaltyNavButton;
